import React, { FC, useEffect } from 'react';

import TrajectoryElement from 'components/statements/TrajectoryList/TrajectoryElement';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';

import terms from '../../../i18n';
import { Trajectory } from '../../../models/applications/enum';
import { applicationsInfoApi } from '../../../redux/api/applications/applications-info-api';
import { selectUser } from '../../../redux/selectors';
import { selectCurrentTrajectory } from '../../../redux/selectors/enrollee/application';
import { applicationSlice } from '../../../redux/slices/enrollee/application-slice';

export const trajectories = {
  [Trajectory.ADDITIONAL]: {
    name: terms.ADDITIONAL,
    content: `${terms.APPLY_CONTRACT_ONLY};\n
    ${terms.GETTING_DORMITORY_ONLY_IF_ANY_LEFT};\n
    ${terms.ADMISSION_INFO_HERE}.`,
  },
  [Trajectory.QUOTA]: {
    name: terms.QUOTA,
    content: `${terms.HAVE_MINOBR_DIRECTION};\n
    ${terms.OPEN_DOORS_WINNER}`,
  },
  // начиная с ПК-26 эта траектория не доступна на UI -
  // поступить по ней можно только через ЕПГУ
  [Trajectory.COMMON]: {
    name: terms.COMMON,
    content: `${terms.STATE_FUNDED_OR_PAID_PLACES};\n
    ${terms.GETTING_DORMITORY_COMPETITIVE};\n
    ${terms.HAS_COMPATRIOT_DOCS},\n
    ${terms.OR_CITIZEN}:\n
    1. ${terms.BELARUS}\n
    2. ${terms.KAZAKHSTAN}\n
    3. ${terms.KYRGYZ}\n
    4. ${terms.TAJIKISTAN}`,
  },
};

const TrajectoryList: FC = () => {
  const dispatch = useAppDispatch();

  const trajectory = useAppSelector(selectCurrentTrajectory);

  const { id } = useAppSelector(selectUser);
  const [getAvailableTrajectories, { data: availableTrajectories }] =
    applicationsInfoApi.useLazyGetPossibleTrajectoriesForUserQuery();

  useEffect(() => {
    if (id) getAvailableTrajectories(id);
  }, [id]);

  const setTrajectory = (value: Trajectory) => {
    dispatch(applicationSlice.actions.setCurrentTrajectory(value));
  };

  return (
    <section className="trajectory-list">
      {(availableTrajectories ?? [])
        // Траектория COMMON недоступна через UI
        // todo временный костыль, открывающий траекторию для подачи документов.
        //  Подробнее в коде app-manager: https://tracker.yandex.ru/ENROLLDEV-597
        // .filter(trajectory => trajectory !== Trajectory.COMMON)
        .map(trajectory => ({
          type: trajectory,
          ...trajectories[trajectory],
        }))
        .map((t, index) => (
          <TrajectoryElement
            key={index}
            name={t.name}
            content={t.content}
            active={t.type === trajectory}
            setTrajectory={() => setTrajectory(t.type)}
          />
        ))}
    </section>
  );
};

export default TrajectoryList;
